export interface SpeciesData {
  sex: string[];
  breeds: string[];
}

export const speciesData: Record<string, SpeciesData> = {
  'Собака': {
    sex: ['Кобель', 'Сука'],
    breeds: ['Акита', 'Аляскинский маламут', 'Бигль', 'Боксёр', 'Бульдог', 'Вест-хайленд-уайт-терьер', 'Далматин', 'Метис', 'Доберман', 'Золотистый ретривер', 'Йоркширский терьер', 'Лабрадор-ретривер', 'Маламут', 'Мопс', 'Немецкая овчарка', 'Пекинес', 'Померанский шпиц', 'Пудель', 'Ротвейлер', 'Русская борзая', 'Сиба-ину', 'Сибирский хаски', 'Такса', 'Чихуахуа', 'Ши-тцу', 'Другая'],
  },
  'Кошка': {
    sex: ['Кот', 'Кошка'],
    breeds: ['Абиссинская', 'Бенгальская', 'Бобтейл', 'Британская короткошерстная', 'Бурманская', 'Вислоухая', 'Метис', 'Курильский бобтейл', 'Мейн-кун', 'Меконгский бобтейл', 'Норвежская лесная', 'Ориентальная', 'Персидская', 'Русская голубая', 'Сиамская', 'Сибирская', 'Сфинкс', 'Шотландская прямоухая', 'Другая'],
  },
  'Кролик': {
    sex: ['Самец', 'Самка'],
    breeds: ['Карликовый', 'Баран', 'Рекс', 'Ангорский', 'Декорактивный', 'Другая'],
  },
  'Хомяк': {
    sex: ['Самец', 'Самка'],
    breeds: ['Сирийский', 'Джунгарский', 'Китайский', 'Кэмпбелла', 'Роборовского', 'Другая'],
  },
  'Морская свинка': {
    sex: ['Самец', 'Самка'],
    breeds: ['Американская', 'Перуанская', 'Абиссинская', 'Коронет', 'Силки', 'Тедди', 'Другая'],
  },
  'Крыса': {
    sex: ['Самец', 'Самка'],
    breeds: ['Дамбо', 'Стандартная', 'Берк', 'Рекс', 'Сфинкс', 'Другая'],
  },
  'Птица': {
    sex: ['Самец', 'Самка'],
    breeds: ['Волнистый попугай', 'Корелла', 'Какаду', 'Ара', 'Амадины', 'Канарейка', 'Перепел', 'Другая'],
  },
  'Черепаха': {
    sex: ['Самец', 'Самка'],
    breeds: ['Сухопутная', 'Красноухая', 'Среднеазиатская', 'Другая'],
  },
  'Другой': {
    sex: ['Самец', 'Самка', 'Неизвестно'],
    breeds: [],
  },
};

export const commonComplaints = [
  'Вялость', 'Снижение аппетита', 'Анорексия', 'Лихорадка', 'Гипотермия',
  'Потеря веса', 'Набор веса', 'Обезвоживание', 'Бледность слизистых',
  'Желтушность слизистых', 'Цианоз', 'Непереносимость нагрузки', 'Коллапс',
  'Беспокойство', 'Боль неуточненная', 'Рвота', 'Регургитация', 'Диарея',
  'Запор', 'Тенезмы при дефекации', 'Кровь в кале', 'Мелена', 'Слизь в кале',
  'Метеоризм', 'Вздутие живота', 'Боль в животе', 'Дисфагия',
  'Гиперсаливация', 'Поедание несъедобного', 'Копрофагия', 'Кашель', 'Чихание',
  'Одышка', 'Тахипноэ', 'Открытое дыхание ртом', 'Шумное дыхание',
  'Выделения из носа', 'Носовое кровотечение', 'Изменение голоса', 'Полиурия',
  'Поллакиурия', 'Дизурия', 'Странгурия', 'Гематурия', 'Анурия', 'Олигурия',
  'Недержание мочи', 'Мочеиспускание вне лотка', 'Изменение цвета мочи',
  'Изменение запаха мочи', 'Полидипсия', 'Снижение жажды', 'Полифагия',
  'Избирательный аппетит', 'Судороги', 'Тремор', 'Атаксия', 'Парез', 'Паралич',
  'Наклон головы', 'Кружение', 'Нистагм', 'Дезориентация', 'Изменение сознания',
  'Гиперестезия', 'Внезапная слепота', 'Изменение поведения', 'Зуд', 'Алопеция',
  'Перхоть', 'Эритема кожи', 'Сыпь', 'Папулы', 'Пустулы', 'Корки на коже',
  'Мокнутие кожи', 'Гиперпигментация', 'Неприятный запах кожи', 'Узел на коже',
  'Рана', 'Расчесы', 'Выделения из глаз', 'Слезотечение', 'Покраснение глаза',
  'Прищуривание', 'Помутнение глаза', 'Увеличение глаза', 'Светобоязнь',
  'Травма глаза', 'Выпадение третьего века', 'Разный размер зрачков',
  'Выделения из уха', 'Запах из уха', 'Зуд ушей', 'Трясет головой', 'Боль в ухе',
  'Тахикардия', 'Брадикардия', 'Аритмия', 'Синкопе', 'Асцит',
  'Периферические отеки', 'Хромота', 'Не опирается на конечность',
  'Боль в суставе', 'Отек сустава', 'Скованность движений', 'Трудно вставать',
  'Не хочет прыгать', 'Боль в спине', 'Боль в шее', 'Деформация конечности',
  'Мышечная слабость', 'Выделения из половых путей', 'Кровянистые выделения',
  'Увеличение молочных желез', 'Выделения из молочных желез',
  'Боль в молочной железе', 'Увеличение семенника', 'Боль в семеннике',
  'Проблемы при родах', 'Неприятный запах изо рта', 'Кровоточивость десен',
  'Боль при жевании', 'Отказ от твердого корма', 'Потеря зуба', 'Сломанный зуб',
  'Отек морды', 'Язвы во рту', 'Агрессия', 'Страх', 'Вокализация',
  'Нарушение сна', 'Компульсивное поведение', 'Разрушительное поведение',
  'Снижение социального контакта', 'Укус', 'Падение с высоты', 'Автотравма',
  'Ожог', 'Переохлаждение', 'Инородное тело', 'Кровотечение',
];

export function normalizeSpecies(value: string): string {
  value = (value || '').trim();
  if (!value) return '';
  if (speciesData[value]) return value;
  const lower = value.toLowerCase();
  for (const key of Object.keys(speciesData)) {
    if (key.toLowerCase() === lower) return key;
  }
  if (lower.includes('собак') || lower.includes('пёс') || lower.includes('щенок')) return 'Собака';
  if (lower.includes('кош') || lower.includes('кот') || lower.includes('котёнок') || lower.includes('котик')) return 'Кошка';
  if (lower.includes('крол')) return 'Кролик';
  if (lower.includes('хомяк')) return 'Хомяк';
  if (lower.includes('морская свинк') || lower.includes('морскую свинк')) return 'Морская свинка';
  if (lower.includes('крыс')) return 'Крыса';
  if (lower.includes('птиц') || lower.includes('попуг') || lower.includes('канарейк')) return 'Птица';
  if (lower.includes('черепах')) return 'Черепаха';
  return 'Другой';
}

export function normalizeSex(value: string, species: string): string {
  value = (value || '').trim().toLowerCase();
  if (!value) return '';
  const sexes = speciesData[species]?.sex || ['Самец', 'Самка', 'Неизвестно'];
  for (const sex of sexes) {
    if (sex.toLowerCase() === value) return sex;
  }
  if (value.includes('кобел') || value.includes('мальчик') || value.includes('самец') || value.includes('мужск') || value === 'кот' || value.includes('котик') || value === 'пёс' || value === 'пес') {
    return sexes.find(s => s.toLowerCase().includes('кобел')) || sexes.find(s => s.toLowerCase().includes('самец')) || sexes[0];
  }
  if (value.includes('сук') || value.includes('девоч') || value.includes('самк') || value.includes('женск') || value === 'кошка' || value.includes('кошечк')) {
    return sexes.find(s => s.toLowerCase().includes('сука')) || sexes.find(s => s.toLowerCase().includes('самка')) || sexes[1];
  }
  return value;
}
